import React from 'react'

export default props => (
	<div className={`card${props.colapsedCard ? ' collapsed-card' : ''}`} style={{ ...props.style, marginBottom: props.marginBottom || 0  }}>
		{props.children}
	</div>
)
